import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=899b6ad4&scoped=true&"
import script from "./Accounting.vue?vue&type=script&lang=js&"
export * from "./Accounting.vue?vue&type=script&lang=js&"
import style0 from "./Accounting.vue?vue&type=style&index=0&id=899b6ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b6ad4",
  null
  
)

export default component.exports